import type { FC } from "react";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import * as z from "zod";
import { Form } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/ui/use-toast";
import { NotificationToggle } from "./NotificationToggle";

const notificationSchema = z.object({
	newMessage: z.boolean(),
	newComment: z.boolean(),
	newFollower: z.boolean(),
	eventReminder: z.boolean(),
	goalUpdate: z.boolean(),
	systemUpdate: z.boolean(),
});

type NotificationValues = z.infer<typeof notificationSchema>;

export const NotificationPreferences: FC = () => {
	const { toast } = useToast();

	const form = useForm<NotificationValues>({
		resolver: zodResolver(notificationSchema),
		defaultValues: {
			newMessage: true,
			newComment: true,
			newFollower: true,
			eventReminder: true,
			goalUpdate: true,
			systemUpdate: true,
		},
	});

	const onSubmit = async (data: NotificationValues) => {
		try {
			// TODO: 通知設定更新のAPI呼び出し
			toast({
				title: "通知設定を更新しました",
				description: "変更内容が保存されました",
			});
		} catch (error) {
			toast({
				title: "エラーが発生しました",
				description: "設定の更新に失敗しました",
				variant: "destructive",
			});
		}
	};

	return (
		<Form {...form}>
			<form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
				<div className="space-y-4">
					<NotificationToggle
						name="newMessage"
						title="新着メッセージ"
						description="新しいメッセージを受信したときに通知"
						control={form.control}
					/>
					<NotificationToggle
						name="newComment"
						title="新着コメント"
						description="投稿にコメントがついたときに通知"
						control={form.control}
					/>
					<NotificationToggle
						name="newFollower"
						title="新規フォロワー"
						description="新しいフォロワーを獲得したときに通知"
						control={form.control}
					/>
					<NotificationToggle
						name="eventReminder"
						title="イベントリマインダー"
						description="登録したイベントの開始前に通知"
						control={form.control}
					/>
					<NotificationToggle
						name="goalUpdate"
						title="目標の更新"
						description="目標の進捗や期限に関する通知"
						control={form.control}
					/>
					<NotificationToggle
						name="systemUpdate"
						title="システム通知"
						description="メンテナンスや重要なお知らせ"
						control={form.control}
					/>
				</div>
				<Button type="submit">変更を保存</Button>
			</form>
		</Form>
	);
};
